import { DatePipe } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterLink } from '@angular/router';
import { LanguageService } from '@backoffice-frontend/shared/util-transloco';
import type {
  Message,
  Notification,
  UserLimitViolation,
} from '@clean-code/models';
import { NotificationItemComponent } from '@clean-code/notifications/feature-notification-center';
import { DateParserService } from '@clean-code/shared/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBoltSlash } from '@fortawesome/pro-solid-svg-icons';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'violation-notification-item',
  templateUrl: './user-limit-violation-notification-item.component.html',
  styleUrls: ['./user-limit-violation-notification-item.component.scss'],
  imports: [
    RouterLink,
    DatePipe,
    MatTooltipModule,
    FontAwesomeModule,
    TranslocoModule,
    NotificationItemComponent,
  ],
})
export class UserLimitViolationNotificationItemComponent implements Notification {
  private router = inject(Router);

  public faBoltSlash = faBoltSlash;

  public message = input.required<Message>();

  public limitViolation = computed(() => {
    const message = this.message();
    if (message?.data) {
      return <UserLimitViolation>(
        JSON.parse(this.message().data, DateParserService.getJsonDateReviver())
      );
    }
    return {} as UserLimitViolation;
  });

  private language: string;
  constructor() {
    const languageService = inject(LanguageService);

    this.language = languageService.currentLocale;
  }

  public itemClicked(/*$event: Event*/) {
    void this.router.navigate([
      `/limits/preview/${this.limitViolation().userLimit.id}`,
    ]);
  }

  // public get translatedProductName(): string {
  //   if (this.limitViolation.product.additionalData) {
  //     const kvp = this.limitViolation.product.additionalData.find(
  //       (x) => x.key === 'caption-' + this.language
  //     );
  //     if (kvp) {
  //       return kvp.value as string;
  //     }
  //   }
  //   //fallback
  //   return this.limitViolation.product.caption;
  // }
}
